<template>
  <div class="page-container">
    <a-page-header
      title="调用详情"
      @back="$router.back()"
      style="padding: 0 0 16px"
    />

    <a-spin :spinning="loading">
      <template v-if="detail">
        <!-- 基础信息 -->
        <a-card title="基础信息" style="margin-bottom: 16px">
          <a-descriptions :column="2" bordered size="small">
            <a-descriptions-item label="ID">{{ detail.id }}</a-descriptions-item>
            <a-descriptions-item label="状态">
              <a-tag :color="detail.status === 1 ? 'green' : 'red'">
                {{ detail.status === 1 ? '成功' : '失败' }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="模型">{{ detail.model_name || '-' }}</a-descriptions-item>
            <a-descriptions-item label="模型来源">{{ detail.model_source || '-' }}</a-descriptions-item>
            <a-descriptions-item label="耗时">{{ detail.duration_ms != null ? detail.duration_ms + ' ms' : '-' }}</a-descriptions-item>
            <a-descriptions-item label="Prompt 长度">{{ detail.prompt_length != null ? detail.prompt_length + ' 字符' : '-' }}</a-descriptions-item>
            <a-descriptions-item label="调用时间" :span="2">{{ detail.create_time }}</a-descriptions-item>
            <a-descriptions-item v-if="detail.error_message" label="错误信息" :span="2">
              <span style="color: red">{{ detail.error_message }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <!-- CSV 信息 -->
        <a-card title="CSV 信息" style="margin-bottom: 16px">
          <a-descriptions :column="2" bordered size="small">
            <a-descriptions-item label="文件名">{{ labelJson.csv_file_name || '-' }}</a-descriptions-item>
            <a-descriptions-item label="行数">{{ labelJson.csv_line_count != null ? labelJson.csv_line_count + ' 行' : '-' }}</a-descriptions-item>
          </a-descriptions>
        </a-card>

        <!-- 完整 Prompt -->
        <a-card title="完整 Prompt" style="margin-bottom: 16px">
          <pre style="max-height: 500px; overflow: auto; white-space: pre-wrap;
                      font-family: monospace; font-size: 12px; background: #f5f5f5;
                      padding: 12px; border-radius: 4px; margin: 0">{{ detail.prompt_content || '（无）' }}</pre>
        </a-card>

        <!-- AI 响应 -->
        <a-card title="AI 原始响应">
          <pre style="max-height: 500px; overflow: auto; white-space: pre-wrap;
                      font-family: monospace; font-size: 12px; background: #f5f5f5;
                      padding: 12px; border-radius: 4px; margin: 0">{{ detail.response_raw || '（无）' }}</pre>
        </a-card>
      </template>
    </a-spin>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getReferenceDataStreamLogById } from '@/api/referenceDataStream';

const route = useRoute();
const loading = ref(false);
const detail = ref(null);

const labelJson = computed(() => {
  if (!detail.value?.label_json) return {};
  try {
    return JSON.parse(detail.value.label_json);
  } catch {
    return {};
  }
});

async function fetchDetail() {
  loading.value = true;
  try {
    const res = await getReferenceDataStreamLogById(route.params.id);
    if (res.data) detail.value = res.data;
  } finally {
    loading.value = false;
  }
}

onMounted(fetchDetail);
</script>
